export default {
    baseStyle: (props) => ({
        tileWrapper: {
            display: { lg: 'flex' },
            alignItems: { lf: 'center' },
            justifyContent: { lg: 'center' },
            flex: { lg: '0 0 calc(25% - 6px)' },
            window: { lg: '100%' },
            marginTop: { base: '40px', lg: 0 },
            marginX: { base: 'auto', lg: 0 },
            paddingX: { lg: 4 },
            maxW: { base: '185px', lg: '100%' },
            minHeight: { lg: '194px' },
            textAlign: { base: 'center' },
            backgroundColor: { lg: 'white' },
        },
        erTile: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: { lg: '40px' }
        },
        erIcon: {
            width: { base: '29px' },
            height: { base: '29px' },
            marginBottom: { base: 5, lg: '10px' }
        },
        erTitle: {
            fontSize: { base: 'md' },
            lineHeight: { base: '20px' },
            fontWeight: { base: 'bold' },
            textTransform: { base: 'uppercase' },
            textDecoration: { base: 'underline' },
            marginBottom: { base: 4, lg: '10px' }
        },
        noDecoration: {
            textDecoration: { base: 'none' },
        },
        erSubtitle: {
            fontSize: { base: 'sm' },
            lineHeight: { base: '18px' }
        },
        erBadge: {
            fontSize: { base: '10px' },
            lineHeight: { base: '100%' },
            fontWeight: {base: 'medium'},
            padding: { base: '1px 8px 3px' },
            ...props?.isMacOS && {
                padding: {base: '0.4em 8px 0.4em'},
            },
            ...props?.isSafari && {
                padding: '0.4em 8px 0.2em',
            },
            ...props?.isAndroid && {
                padding: {base: '0.4em 8px 0.4em'},
            },
            // MacOS and Chrome
            ...(props?.isMacOSChrome && {
                padding: {base: '0.5em 8px 0.35em'},
            }),
            border: { base: `${props?.DescriptionBorderWidth || '1px'} solid` },
            borderColor: { base: props?.DescriptionBorderColor || 'black' }
        }
    })
}
